import React from "react";
import millify from "millify";
import { Typography, Row, Col, Statistic } from "antd";
import { Link } from "react-router-dom";
import { useGetCryptosQuery } from "../services/cryptoApi";
import { Cryptocurrencies, News, Loader } from ".";

const { Title } = Typography;

const Homepage = () => {
    const { data, isFetching } = useGetCryptosQuery(12);
    const globalStats = data?.data?.stats;

    if (isFetching) return <Loader />;

    return (
        <>
            <Title level={2} className="heading">
                Global Crypto Stats
            </Title>
            <Row>
                <Col span={12}>
                    <Statistic
                        title="Total Cryptocurrencies"
                        value={globalStats?.total}
                    ></Statistic>
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total Exchanges"
                        value={millify(globalStats?.totalExchanges)}
                    ></Statistic>
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total Market Cap"
                        value={millify(globalStats?.totalMarketCap)}
                    ></Statistic>
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total 24h volume"
                        value={millify(globalStats?.total24hVolume)}
                    ></Statistic>
                </Col>
                <Col span={12}>
                    <Statistic
                        title="Total Markets"
                        value={globalStats?.totalMarkets}
                    ></Statistic>
                </Col>
            </Row>
            <div className="home-heading-container">
                <Title level={2} className="home-title">
                    Top 10 Cryptos in the world
                </Title>
                <Title level={3} className="show-more">
                    <Link to="/cryptocurrencies" className="show-more-link">
                        Show more
                    </Link>
                </Title>
            </div>
            <Cryptocurrencies simplified={true} />
            <div className="home-heading-container">
                <Title level={2} className="home-title">
                    Latest Crypto News
                </Title>
                <Title level={3} className="show-more">
                    <Link to="/news">Show more</Link>
                </Title>
            </div>
            <News simplified={true} />
        </>
    );
};

export default Homepage;
